import axios from 'axios';

export const chatBot = (budget, userMessage) => {
  return axios.get(`${process.env.REACT_APP_FINDCAR_API}chatbot/${budget}/${userMessage}`);
};

export const wakaonlineChatbot = (noOfPassengers, fuelType, totalBudget, monthlyRunningCost, monthlyTravelBudget, safetyFeatures, advancedFeatures, overallChoices) => {
  return axios.get(`${process.env.REACT_APP_FINDCAR_API}wakaonlinechatbot/${noOfPassengers}/${fuelType}/${totalBudget}/${monthlyRunningCost}/${monthlyTravelBudget}/${safetyFeatures}/${advancedFeatures}/${overallChoices}`);
};
